import { connect } from 'react-redux';
import Tab from './Tab.jsx';

const TabsContainer = ({ activeTab, handleTabClick, tiles }) => {
  const unscheduledTilesState = 'plan';
  const suggestedTilesState = 'user_submitted';
  const unscheduledTiles = tiles[unscheduledTilesState].tiles;
  const unscheduledAmount = unscheduledTiles.filter(
    tile => tile.planDate === null,
  ).length;
  const suggestedAmount = tiles[suggestedTilesState].tiles.length;

  return (
    <div>
      <Tab
        id="unscheduled"
        text="Unscheduled"
        tilesAmount={unscheduledAmount}
        handleTabClick={handleTabClick}
        activeTab={activeTab}
      />
      <Tab
        id="suggested"
        text="Suggested"
        tilesAmount={suggestedAmount}
        handleTabClick={handleTabClick}
        activeTab={activeTab}
      />
    </div>
  );
};

const mapStateToProps = state => ({
  tiles: state.tiles.tiles,
});

export { TabsContainer };

export default connect(mapStateToProps)(TabsContainer);
